export interface DateRangeSelectionEvent {
  dateFrom: Date | null;
  dateTo: Date | null;
}

export enum DateRangeWeekDay {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7
}
